/**
 * Created by sunjinyu on 2018/11/12.
 */
import Vue from 'vue'
export default {
  login: ({commit}, data) => {
    return new Promise(function (resolve, reject) {
      commit('SET_USER_INFO', data);
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js